module.exports = __webpack_public_path__ + "media/images/map-icons/mapbox-whiteblack-2ae7458f869b295879207a31082bf8d1.png";